import { isDevEnv } from '@/shared/env';

if (typeof window === 'object' && window._resDistRoot && !isDevEnv) {
    if (window._manageMode) {
        __webpack_public_path__ = window._resDistRoot;
    } else {
        __webpack_public_path__ = window._resDistRoot + 'client/';
    }
}
